import styled from "styled-components";

export const Container = styled.div`
  position: relative;
  input {
    width: 150px;
    padding: 0.5rem;
    border-radius: 24px;
    border: 1px solid gray;
    box-shadow: none;
  }
  .popupContainer {
    position: absolute;
    display: none;
    width: 300px;
    height: fit-content;
    max-height: 30vh;
    background: white;
    border-radius: 24px;
    box-shadow: 0 0 10px rgb(0 0 0 / 0.2);
    z-index: 100;
    overflow: scroll;
    top: 110%;
    right: -50%;
    &.active {
      display: flex;
    }
    &::-webkit-scrollbar {
      display: none;
    }
    ul {
      width: 100%;
      padding: 1rem;
      a {
        text-decoration: none;
        color: black;

        li {
          list-style: none;
          padding: 0.5rem 0;
          width: 100%;
          :hover {
            background: rgba(255, 106, 0, 0.5);
          }
        }
      }
    }
  }
  @media (min-width: 867px) {
    input {
      width: 300px;
    }
    .popupContainer {
      right: 0;
    }
  }
`;
